<template>
  <div class="path">
    <div ref="scroller" class="path__scroll">
      <CardFace
        v-for="(card, i) in game.path"
        :key="`${card.id}-${i}`"
        :card-id="card.id"
        :left="card.left"
        :newest="i === game.path.length - 1"
        :deadly="isEndingCard(card, i)"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CardFace from '@/components/game/CardFace.vue';
import { cardById, isHazard } from '@/engine/deck';
import { ROUND_END_REASONS } from '@/engine/constants';

// The cards turned over so far this expedition, oldest first.
//
// It scrolls rather than wrapping, and it auto-scrolls to the end whenever a
// card lands, because the newest card is the only one you urgently need to
// see - the older ones matter only as a running tally of which hazards have
// already shown, which is readable at a glance from their pictures.
export default {
  name: 'TemplePath',
  components: { CardFace },
  computed: {
    ...mapState(['game']),
    pathLength() { return this.game?.path.length || 0; },
  },
  watch: {
    pathLength() {
      this.$nextTick(this.scrollToEnd);
    },
  },
  mounted() {
    this.scrollToEnd();
  },
  methods: {
    scrollToEnd() {
      const el = this.$refs.scroller;
      if (el) el.scrollLeft = el.scrollWidth;
    },
    /** The second-of-its-type that ended the round, so it can be marked. */
    isEndingCard(card, i) {
      if (this.game.meta.roundOver?.reason !== ROUND_END_REASONS.HAZARD) return false;
      if (i !== this.game.path.length - 1) return false;
      const face = cardById(card.id);
      return isHazard(face) && face.hazard === this.game.meta.roundOver.hazard;
    },
  },
};
</script>
